import type {
  AnswerShareManageState,
  AnswerSharePublicInfo,
  AnswerShareSummary,
  AnswerShareUnlockResponse,
} from "../../types/answerShare";

function readString(value: unknown): string | null {
  return typeof value === "string" && value.trim() !== "" ? value.trim() : null;
}

function readBool(value: unknown): boolean | undefined {
  return typeof value === "boolean" ? value : undefined;
}

export function normalizeAnswerShareManage(
  raw: unknown,
): AnswerShareManageState {
  if (!raw || typeof raw !== "object") {
    return { exists: false };
  }

  const item = raw as Record<string, unknown>;
  const exists = item.exists === true;

  return {
    exists,
    enabled: readBool(item.enabled),
    token: readString(item.token),
    expiresAt: readString(item.expiresAt ?? item.expires_at),
  };
}

export function normalizeAnswerShareSummary(raw: unknown): AnswerShareSummary {
  if (!raw || typeof raw !== "object") {
    return { exists: false };
  }

  const item = raw as Record<string, unknown>;
  return {
    exists: item.exists === true,
    enabled: readBool(item.enabled),
    expiresAt: readString(item.expiresAt ?? item.expires_at),
  };
}

export function normalizeAnswerSharePublic(
  raw: unknown,
): AnswerSharePublicInfo {
  if (!raw || typeof raw !== "object") {
    return { formName: "Форма" };
  }

  const item = raw as Record<string, unknown>;
  const formName =
    readString(item.formName ?? item.form_name ?? item.name) ?? "Форма";

  return {
    formName,
    source: readString(item.source),
    expiresAt: readString(item.expiresAt ?? item.expires_at),
  };
}

export function normalizeAnswerShareUnlock(
  raw: unknown,
): AnswerShareUnlockResponse {
  if (!raw || typeof raw !== "object") {
    throw new Error("Некорректный ответ unlock");
  }

  const item = raw as Record<string, unknown>;
  const accessToken = readString(item.accessToken ?? item.access_token);
  if (!accessToken) {
    throw new Error("Ответ unlock не содержит accessToken");
  }

  return {
    accessToken,
    expiresAt: readString(item.expiresAt ?? item.expires_at),
  };
}
